import {
  WORK_SCHEDULE_REQUEST,
  WORK_SCHEDULE_RECEIVED,
  WORK_SCHEDULE_ERROR,
  WORK_SCHEDULE_UNLOAD,
  WORK_SCHEDULE_SET_DATE,
  WORK_SCHEDULE_SINGLE_RECEIVED,
} from '../constants';

const reducer = (
  state = {
    workSchedules: [],
    isFetchingWorkSchedule: false,
    currentDate: undefined,
  },
  action,
) => {
  switch (action.type) {
    case WORK_SCHEDULE_REQUEST:
      return {
        ...state,
        workSchedules: [],
        isFetchingWorkSchedule: true,
      };

    case WORK_SCHEDULE_RECEIVED:
      return {
        ...state,
        workSchedules: action.data['hydra:member'],
        isFetchingWorkSchedule: false,
        currentDate: action.date,
      };
    case WORK_SCHEDULE_SINGLE_RECEIVED: {
      let workSchedules = state.workSchedules.filter((x) => x.id === action.data.id);
      if (workSchedules.length === 0) {
        workSchedules = [...state.workSchedules, action.data];
      } else {
        workSchedules = [
          ...state.workSchedules.map((x) => {
            return action.data.id === x.id ? action.data : x;
          }),
        ];
      }
      return {
        ...state,
        workSchedules: workSchedules,
        isFetchingWorkSchedule: false,
      };
    }

    case WORK_SCHEDULE_ERROR:
      return {
        ...state,
        isFetchingWorkSchedule: false,
      };

    case WORK_SCHEDULE_UNLOAD:
      return {
        workSchedules: [],
        isFetchingWorkSchedule: false,
        currentDate: undefined,
      };

    case WORK_SCHEDULE_SET_DATE:
      return {
        ...state,
        currentDate: action.date,
      };

    default:
      return state;
  }
};

export default reducer;
